import * as API from "../data/property_visit_api";
import { signOutAction } from "./auth_actions";

export const GET_CREATE_PV_REPORT_DETAILS = "get_pv_report_details_for_creation";
export const CLEAR_DATA = "clear_old_data";

export function getPVReportById(reportId) {
    return async (dispatch) => {
        dispatch({type: CLEAR_DATA});
        const response = await API.getPVReportById(reportId);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            if(response.status === 403){
            }
            else {
                dispatch({
                    type: GET_CREATE_PV_REPORT_DETAILS,
                    payload: response
                });
            }
        }
    };
}


// WEBPACK FOOTER //
// ./src/actions/property_visit_action.js